/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';
import { modelFactory as ticketFormat } from '../ticket/model';
import { modelFactory as catalogFormat } from '../catalog/model';

export default class DashboardClient extends SearchClient {
  constructor(options = {}) {
    super(options);
    this.__search = super.cancelableSearch.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  search() {
    throw new Error('disabled method for Dashboard client');
  }

  userPendingRequests(status) {
    const req = this.__search({
      target: 'namedquery',
      entity: 'ticketsUserPending',
      filters: {
        status,
      },
      first: 0,
      size: 5,
    });

    req.format = this.format.bind({
      $formatter: ticketFormat.format,
    });
    return req;
  }

  myRequests(status) {
    const req = this.__search({
      target: 'namedquery',
      entity: 'ticketsUserRequests',
      filters: {
        status,
      },
      first: 0,
      size: 5,
    });

    req.format = this.format.bind({
      $formatter: ticketFormat.format,
    });

    return req;
  }

  requestsForms(text) {
    const req = this.__search({
      target: 'namedquery',
      entity: 'catalogsByName',
      filters: {
        type: 'R',
        text: text != null && text.trim() !== '' ? text : undefined,
      },
      first: 0,
      size: 4,
    });

    req.format = this.format.bind({
      $formatter: catalogFormat.format,
    });

    return req;
  }

  incidentsForms(text) {
    const req = this.__search({
      target: 'namedquery',
      entity: 'catalogsByName',
      filters: {
        type: 'I',
        text: text != null && text.trim() !== '' ? text : undefined,
      },
      first: 0,
      size: 4,
    });

    req.format = this.format.bind({
      $formatter: catalogFormat.format,
    });

    return req;
  }

  async callToMe(data) {
    try {
      const response = await this.request('post')(
        { data },
        { path: 'dasd/calltome' },
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }
/*
  async search({
    query, entities = ['tickets', 'kis'], first, size, order,
  }) {
    let firstP = first;
    let sizeP = size;

    if (sizeP < 0 || sizeP > 10) {
      sizeP = 10;
    }

    if (firstP > sizeP) {
      firstP = 0;
    } else if (firstP < 0) {
      firstP = 0;
    }
    try {
      const response = await this.request('get')({
        entities,
        query,
        order,
        first: firstP,
        size: sizeP,
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  } */
}
